import { render, staticRenderFns } from "./products_group.vue?vue&type=template&id=4e0a783e&scoped=true&"
import script from "./products_group.vue?vue&type=script&lang=js&"
export * from "./products_group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0a783e",
  null
  
)

export default component.exports